import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

const mock = [
  { id: '00000000-0000-0000-0000-000000000001', value: 'Основний' },
  { id: '00000000-0000-0000-0000-000000000002', value: 'Контрольний' },
  { id: '00000000-0000-0000-0000-000000000003', value: 'Підмінний' },
];

const index = new AxiosMockAdapter(instance);

index
  .onGet(/\/api\/metering-node-kinds\/?(?:\?.*)?$/)
  .reply(200, mock)
  .onAny()
  .passThrough();
